<!-- checkOut -->
<template>
  <div class="checkOut" :class="{ inApp: $root.$data.isApp }">
    <common-title titleName="支付中心" :zIndex="1000"></common-title>
    <van-loading
      class="checkOutLoading"
      color="#ff6c02"
      size="60px"
      text-size="18px"
      vertical
      v-if="statusLoading"
    >
      订单状态确认中...
    </van-loading>
    <template v-else>
      <template v-if="loading">
        <commonLoading />
      </template>
      <template v-else>
        <section class="orderInfo">
          <div>
            <p class="orderPrice">￥{{ Number(orderAmount).toFixed(2) }}</p>
            <p class="orderDiscount" v-if="this.source !== 1">
              <span class="text">已优惠：</span>
              <span class="price">￥{{ Number(discountAmount).toFixed(2) }}</span>
            </p>
            <p class="orderNo">
              <span class="text"
                >{{
                  this.source === 1
                    ? '售后单号：'
                    : this.source === 3 || this.source === 4
                    ? '定金单号：'
                    : '订单编号：'
                }}
                {{ orderNo }}</span
              >
              <button @click="orderNoCopy" class="copyButton"></button>
            </p>
          </div>
        </section>
        <!-- <section class="tokenMoneyChoose">
      <span class="nameText">帆贝</span>
      <span class="tokenMoneyTotal">{{tokenMoneyTotal}}</span>
      <span class="nameText">可抵用</span>
      <span class="tokenMoneyCanBeUsed">{{tokenMoneyCanBeUsed}}</span>
      <button></button>
    </section> -->
        <section class="tokenMoneyDetail"></section>
        <section class="payInfo">
          <p class="sectionTitle">选择支付方式</p>
          <pay-methods-list
            grouped
            :payMethodsList="payMethodsListData"
            :huabeiList="huabeiList"
            :baitiaoList="baitiaoList"
          />
        </section>
        <section class="pay-agreement" v-if="this.source !== 1">
          <span :class="['payProtocol', { payProtocolActive }]" @click="protocolActiveChange">
            已同意
          </span>
          <template v-if="agreementList.length > 0">
             <span v-for="(item, index) in agreementList" :key="index" @click="showqihangAgree(item)">
            《{{ item.name }}》<span v-if="index < agreementList.length - 1">、</span>
          </span>
          </template>
          <span v-else @click="goPage()"
            >《{{ memberPackage ? '会员服务协议' : '用户购买协议' }}》</span
          >
        </section>
        <section class="bottomButton">
          <div class="handsel" v-if="source === 3">
            定金不可退款，若需退款可在支付尾款后申请退款
          </div>
          <!-- <p v-if="Number(orderAmount) > 5000" class="customerService">
            <span class="text">支付遇到问题？请联系客服</span>
            <i class="customerServiceIcon"></i>
          </p> -->
          <button
            @click="pay"
            :class="
              !(payProtocolActive && payMethodsListData.find((payMethod) => payMethod.active))
                ? 'buttonUnactive'
                : ''
            "
          >
            立即支付 ￥{{ orderAmount }}
          </button>
        </section>
      </template>
    </template>
  </div>
</template>

<script>
import { setBaseUrl, copyTool, getWechatAppId } from '@/utils/tools';
import commonLoading from '@/components/commonComponents/CommonLoading.vue';

import {
  payIcons,
  payTypeMap,
  HUABEI_TYPE,
  HUABEI_TYPE_ID,
  BAITIAO_TYPE,
  BAITIAO_TYPE_ID,
} from '@/assets/js/payConfig';
import {
  reqPayInfo,
  reqHuabeiInfo,
  reqOrderValidation,
  reqPayImmediate,
  reqPayResult,
  reqReturnClassCashierInfo,
  reqReturnClassImmediatepay,
  reqReturnPayResult,
  reqPostGroupPayPayment,
  reqGetGroupCashierInfo,
  reqGetGroupPayResult,
  reqGetDepositDeskInfo,
  reqGetDepositPayResult,
  reqGetDepositPayVerify,
  reqPostDepositPayment,
} from '@/api/pay';
import payMethodsList from './checkOutComponents/payMethodsList.vue';
import { reqOrderDetail } from '@/api/personal/orderController';

export default {
  data() {
    return {
      source: Number(this.$route.query.source), // 1 退换课来源 2 拼团  3 定金 4 定金尾款
      isOrderAddres: this.$route.query.isOrderAddres,
      orderAmount: 0,
      discountAmount: 0,
      orderNo: '',
      // tokenMoneyTotal: 50,
      payMethodsListData: [],
      huabeiList: [],
      baitiaoList: [],
      payProtocolActive: false,
      statusLoading: false,
      timer: null, // 定时器
      wxCode: null, // 微信授权的code
      loading: true,
      groupId: '',
      depositStatus: 0, // 定金单当前状态 1-待付定金 2-定金单已取消 3-定金单超时关闭 4-待付尾款（已付定金） 5-尾款已支付 6-尾款已关闭（超时未支付）
      point: false,
      memberPackage: false,
      agreementList: [],
    };
  },
  components: {
    payMethodsList,
    commonLoading,
  },
  async mounted() {
    this.loading = true;
    this.orderNo = this.$route.query.orderNo;
    this.getOrderDetail(this.orderNo);
    // 拼团与退换课跳过订单校验
    if (this.source !== 1 && this.source !== 2) {
      await this.orderValid();
    } else if (this.source === 2 && !this.$root.$data.isWeiXin) {
      // 拼团订单存储来源，用作拼团详情页面拼团成功弹窗
      sessionStorage.setItem('groupProgressSource', 'cashier');
    }
    // 进入页面查询支付结果，免费课直接跳转
    await this.payStatusConfirm();
    await this.payInfoInit();
    if (this.$route.query.needConfirm) {
      this.processConfirm();
    }
    if (this.$route.query.state && this.$route.query.state === 'weixinredirect') {
      this.wxCode = this.$route.query.code;
      this.payProtocolActive = true;
      this.pay();
    }
  },
  methods: {
    showqihangAgree(item) {
      const itemStr = encodeURIComponent(JSON.stringify(item));
      this.$router.push({
        path: 'qihangSchoolAgreementDetail',
        query: {
          xieyiInfo: itemStr
        },
      });
    },

    goPage() {
      this.$router.push({ name: 'payAgreement' });
    },
    wxpay(val) {
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(val), false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(val));
          document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(val));
        }
      } else {
        this.onBridgeReady(val);
      }
    },

    onBridgeReady(val) {
      const that = this;
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: val.appid, // 公众号名称，由商户传入
          timeStamp: `${val.timeStamp}`, // 时间戳，自1970年以来的秒数
          nonceStr: val.nonceStr, // 随机串
          package: val.packages,
          signType: val.signType, // 微信签名方式:
          paySign: val.paySign, // 微信签名
        },
        (res) => {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            if (this.source === 2) {
              this.$router.replace({
                path: '/groupProgress',
                query: { groupId: this.groupId },
              });
            } else {
              that.$router.replace({
                path: 'paySuccess',
                query: {
                  orderNo: this.$route.query.orderNo,
                  source: this.source,
                  isOrderAddres: this.isOrderAddres,
                },
              });
            }
          } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            this.$toast('支付失败...');
            if (this.$root.$data.isWeiXin) {
              this.$router.replace({
                path: 'cashier',
                query: {
                  orderNo: this.$route.query.orderNo,
                  source: this.$route.query.source || '',
                  groupId: this.$route.query.groupId || '',
                },
              });
            }
          }
        },
      );
    },
    // 支付校验--是否有购买过的商品
    async orderValid() {
      if (this.$route.query.needConfirm) return;
      let response = null;
      // 定金校验
      if (this.source === 3 || this.source === 4) {
        response = await reqGetDepositPayVerify({
          depositOrderNo: this.orderNo,
        });
      } else {
        // 普通订单套餐价格为0时不校验
        if (Number(sessionStorage.getItem('payable')) === 0) return;
        // 普通定单校验
        response = await reqOrderValidation({
          orderNo: this.orderNo,
        });
      }
      if (response?.code) {
        this.$toast('订单校验失败');
      } else if (response?.data?.repeatBuyProductNameList?.length) {
        this.$toast(
          `订单内商品${response?.data?.repeatBuyProductNameList?.join()}不能重复购买，请重新下单`,
        );
      }
    },
    // 查询订单信息
    async payInfoInit() {
      let response = null;
      // 退换课
      if (this.source === 1) {
        response = await reqReturnClassCashierInfo({
          changeNo: this.orderNo,
        });
      } else if (this.source === 2) {
        // 拼团
        response = await reqGetGroupCashierInfo({
          groupOrderNo: this.orderNo,
        });
      } else if (this.source === 3 || this.source === 4) {
        // 定金
        response = await reqGetDepositDeskInfo(this.orderNo, this.source === 3 ? 1 : 2);
      } else {
        // 普通订单
        response = await reqPayInfo({
          orderNo: this.orderNo,
        });
      }
      this.loading = false;
      if (response?.code) {
        this.$toast('支付信息初始化失败');
      } else {
        // console.log(response, 666);
        const responseData = response?.data || {};
        if (this.source === 1) {
          this.payProtocolActive = true;
          Object.assign(responseData, { orderAmount: responseData.fillAmount });
        }
        if (this.source === 3 || this.source === 4) {
          Object.assign(responseData, {
            orderAmount: responseData.payAmount,
            depositStatus: responseData.status,
          });
        }
        Object.assign(this, responseData);
        const payList = [20, 30, 10, 50];
        const payType = responseData?.payTypeList || [];
        payType.sort((a, b) => payList.indexOf(a) - payList.indexOf(b));
        const payTypeIds = payType;
        const huabeiValid =
          payTypeIds.some((payTypeId) => payTypeId === HUABEI_TYPE_ID) && this.orderAmount >= 100;
        const jdValid = payTypeIds.some((payTypeId) => payTypeId === BAITIAO_TYPE_ID);
        this.agreementList = responseData?.agreementList || [];
        this.payMethodsListData = payTypeIds
          .filter((payTypeId) => this.orderAmount >= 100 || payTypeId !== HUABEI_TYPE_ID)
          .map((payTypeId, payTypeIndex) => ({
            icon: payIcons[payTypeId],
            type: payTypeMap[payTypeId],
            active: !payTypeIndex,
          }));
        if (huabeiValid || jdValid) {
          this.huabeiInit();
        }
      }
    },
    processConfirm() {
      this.$dialog
        .confirm({
          title: '是否已完成支付',
          confirmButtonText: '已完成支付',
          cancelButtonText: '尚未支付',
        })
        .then(() => {
          this.statusLoading = true;
          this.loopPayStatus();
          // this.payStatusConfirm();
        })
        .catch(() => {});
    },
    loopPayStatus() {
      let count = 0;
      this.timer = setInterval(() => {
        count += 1;
        if (count > 5) {
          if (this.timer) clearInterval(this.timer);
          this.timer = null;
          this.statusLoading = false;
          this.$toast('订单状态确认有误，请重新支付');
        }
        this.payStatusConfirm('loop');
      }, 1000);
    },
    async payStatusConfirm(source) {
      const { orderNo } = this;
      let response = null;
      if (this.source === 1) {
        // 退换课校验
        response = await reqReturnPayResult({
          changeNo: orderNo,
        });
      } else if (this.source === 2) {
        // 拼团校验
        response = await reqGetGroupPayResult({
          groupOrderNo: orderNo,
        });
      } else if (this.source === 3 || this.source === 4) {
        // 定金校验
        response = await reqGetDepositPayResult({
          depositOrderNo: orderNo,
        });
      } else {
        // 普通订单
        response = await reqPayResult({
          orderNo,
        });
      }
      if (response?.code) {
        throw new Error(response?.msg);
      }
      if (response.code === 0 && this.source === 2) {
        this.groupId = response.data.groupId;
      }
      if (
        response?.data?.changeStatus === 4 ||
        response?.data?.paySuccess ||
        response?.data?.groupOrderStatus >= 2 ||
        (response?.data?.depositPayResult === 1 && this.source === 3) ||
        (response?.data?.balancePayResult === 1 && this.source === 4)
      ) {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
        if (this.$root.$data.isApp && source === 'loop') {
          this.$sendToApp('wechatBuy', { orderNo }, false);
        } else if (this.source === 2) {
          this.$router.replace({
            path: '/groupProgress',
            query: { groupId: response?.data?.groupId },
          });
        } else {
          this.$router.replace({
            path: 'paySuccess',
            query: { orderNo, source: this.source },
          });
        }
      }
    },
    huabeiInit() {
      reqHuabeiInfo({
        payAmount: this.orderAmount,
      }).then((response) => {
        if (response?.code) {
          this.$toast('花呗信息初始化失败');
        } else {
          const huabeiData = response?.data || {};
          this.huabeiList = huabeiData?.huaBeiPayableRespVOList || [];
          this.baitiaoList = huabeiData?.huaBeiPayableRespVOList || [];
        }
      });
    },
    orderNoCopy() {
      copyTool(this.orderNo)
        .then(() => {
          this.$toast('复制成功');
        })
        .catch(() => {
          this.$toast('复制失败');
        });
    },
    methodSelect(selectedPayMethod) {
      this.payMethodsList.forEach((payMethod) => {
        Object.assign(payMethod, { active: false });
      });
      Object.assign(selectedPayMethod, { active: true });
    },
    protocolActiveChange() {
      this.payProtocolActive = !this.payProtocolActive;
    },
    async pay() {
      if (!this.payProtocolActive) {
        this.$toast(`请先同意《${this.memberPackage ? '会员服务协议' : '用户购买协议'}》`);
        return;
      }
      const payType = this.payMethodsListData.find((payMethod) => payMethod.active);
      const payMethod = Number(
        Object.entries(payTypeMap).find((keyValue) => keyValue[1] === payType.type)[0],
      );
      // 白条
      const isChooseBaiTiao =
        payType.type === BAITIAO_TYPE
          ? Number(
              (this.baitiaoList.find((huabeiPayMethod) => huabeiPayMethod.active) || {}).payableNum,
            )
          : undefined;
      let payment = payMethod === 10 ? payMethod + 1 : payMethod + 2;

      if (isChooseBaiTiao) {
        payment = isChooseBaiTiao && this.$root.$data.isApp ? 52 : 53;
      }
      if (this.point) return;
      this.point = true;
      if (this.$root.$data.isApp) {
        this.appPay(payMethod);
        if (!this.$root.$data.isApp) {
          setTimeout(() => {
            this.processConfirm();
          }, 2000);
        }
        return;
      }

      const wechatAppId = await getWechatAppId('pay');
      let response = null;
      this.loading = true;

      if (this.$root.$data.isWeiXin && !isChooseBaiTiao) {
        // 在微信客户端时使用微信公众号授权并调起支付
        // 在获取到当前url为微信重定向后的链接时，调用支付接口
        // source 1：退换课 2：拼团 3 定金 4 定金尾款
        if (this.$route.query.state && this.$route.query.state === 'weixinredirect') {
          if (this.source === 1) {
            response = await reqReturnClassImmediatepay({
              appId: wechatAppId,
              wxCode: this.wxCode,
              changeNo: this.orderNo,
              payment: 12,
              platform: 1,
              usedBalanceAmount: 0,
              usedBalanceOnlyStatus: 0,
              usedBalanceStatus: 0,
            });
          } else if (this.source === 2) {
            response = await reqPostGroupPayPayment({
              appId: wechatAppId,
              wxCode: this.wxCode,
              groupOrderNo: this.orderNo,
              payment: 12,
              platform: 1,
              userId: this.$store.state.userInfo.id,
            });
          } else if (this.source === 3) {
            response = await reqPostDepositPayment({
              appId: wechatAppId,
              wxCode: this.wxCode,
              depositOrderNo: this.orderNo,
              payment: 12,
              platform: 1,
              userId: this.$store.state.userInfo.id,
              usedBalanceStatus: 0,
            });
          } else if (this.source === 4) {
            response = await reqPostDepositPayment({
              appId: wechatAppId,
              wxCode: this.wxCode,
              depositOrderNo: this.orderNo,
              payment: 12,
              platform: 1,
              userId: this.$store.state.userInfo.id,
              usedBalanceStatus: 0,
            });
          } else {
            response = await reqPayImmediate({
              appId: wechatAppId,
              wxCode: this.wxCode,
              orderNo: this.orderNo,
              payment: 12,
              platform: 1,
              usedBalanceAmount: 0,
              usedBalanceOnlyStatus: 0,
              usedBalanceStatus: 0,
            });
          }
        } else {
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wechatAppId}&redirect_uri=${setBaseUrl(
            'default',
          )}/ark/cashier?orderNo=${this.$route.query.orderNo}%26source=${
            this.$route.query.source
          }&response_type=code&scope=snsapi_base&state=weixinredirect&connect_redirect=1#wechat_redirect`;
        }
      } else if (this.source === 1) {
        response = await reqReturnClassImmediatepay({
          // hbFqSellerPercent: 'string',
          hbfqNum:
            payType.type === HUABEI_TYPE
              ? Number(
                  (this.huabeiList.find((huabeiPayMethod) => huabeiPayMethod.active) || {})
                    .payableNum,
                )
              : undefined,
          btfqNum:
            payType.type === BAITIAO_TYPE
              ? Number(
                  (this.baitiaoList.find((huabeiPayMethod) => huabeiPayMethod.active) || {})
                    .payableNum,
                )
              : undefined,
          changeNo: this.orderNo,
          payment,
          platform: 1,
          usedBalanceAmount: 0,
          usedBalanceOnlyStatus: 0,
          usedBalanceStatus: 0,
        });
      } else if (this.source === 2) {
        response = await reqPostGroupPayPayment({
          hbfqNum:
            payType.type === HUABEI_TYPE
              ? Number(
                  (this.huabeiList.find((huabeiPayMethod) => huabeiPayMethod.active) || {})
                    .payableNum,
                )
              : undefined,
          groupOrderNo: this.orderNo,
          payment,
          platform: 1,
          userId: this.$store.state.userInfo.id,
        });
      } else if (this.source === 3 || this.source === 4) {
        response = await reqPostDepositPayment({
          hbfqNum:
            payType.type === HUABEI_TYPE
              ? Number(
                  (this.huabeiList.find((huabeiPayMethod) => huabeiPayMethod.active) || {})
                    .payableNum,
                )
              : undefined,
          btfqNum:
            payType.type === BAITIAO_TYPE
              ? Number(
                  (this.baitiaoList.find((huabeiPayMethod) => huabeiPayMethod.active) || {})
                    .payableNum,
                )
              : undefined,
          depositOrderNo: this.orderNo,
          payment,
          platform: 1,
          hb_fq_seller_percent: 100,
          userId: this.$store.state.userInfo.id,
          usedBalanceStatus: 0,
        });
      } else {
        response = await reqPayImmediate({
          // hbFqSellerPercent: 'string',
          hbfqNum:
            payType.type === HUABEI_TYPE
              ? Number(
                  (this.huabeiList.find((huabeiPayMethod) => huabeiPayMethod.active) || {})
                    .payableNum,
                )
              : undefined,
          btfqNum:
            payType.type === BAITIAO_TYPE
              ? Number(
                  (this.baitiaoList.find((huabeiPayMethod) => huabeiPayMethod.active) || {})
                    .payableNum,
                )
              : undefined,
          orderNo: this.orderNo,
          payment,
          platform: 1,
          usedBalanceAmount: 0,
          usedBalanceOnlyStatus: 0,
          usedBalanceStatus: 0,
        });
      }

      this.loading = false;
      this.point = false;
      // 但在微信浏览器环境且当前页面不是回调页面时，中断方法
      if (this.$root.$data.isWeiXin && !this.$route.query.code && !isChooseBaiTiao) {
        return;
      }
      // 微信浏览器环境调起微信支付
      if (this.$root.$data.isWeiXin && !isChooseBaiTiao) {
        if (response.code === 0) {
          this.wxpay(response.data.unifyPayRespVO.result);
        }
        return;
      }
      if (response?.code) {
        this.$toast(`因${response?.msg}，支付失败`);
      } else if (response?.data?.unifyPayRespVO?.wapUrl || response?.data?.unifyPayRespVO?.qrCode) {
        const { wapUrl, qrCode } = response?.data?.unifyPayRespVO;
        const backUrl = window.encodeURIComponent(`${window.location.href}&needConfirm=true`);
        // 支付时，先拼接可以弹出支付弹窗的路由
        const { ...query } = this.$route.query;
        await this.$router.replace({ query: { ...query, needConfirm: true } });
        window.location.href = `${wapUrl || qrCode}${
          payMethod === 10 ? `&redirect_url=${backUrl}` : ''
        }`;
        setTimeout(() => {
          this.processConfirm();
        }, 2000);
      } else {
        this.$toast('跳转失败，请联系管理员');
      }
    },
    appPay(payMethod) {
      const { orderNo } = this;
      switch (true) {
        case payMethod === 10:
          this.$sendToApp('wechatBuy', { orderNo }, false);
          break;
        case payMethod === 20:
          this.$sendToApp('aliBuy', { orderNo }, false);
          break;
        case payMethod === 50:
          this.$sendToApp(
            'jdBuy',
            {
              orderNo,
              bt_fq_num:
                Number(
                  (this.baitiaoList.find((huabeiPayMethod) => huabeiPayMethod.active) || {})
                    .payableNum,
                ) || null,
            },
            false,
          );
          break;
        default:
          this.$sendToApp(
            'aliBuy',
            {
              orderNo,
              hb_fq_num:
                Number(
                  (this.huabeiList.find((huabeiPayMethod) => huabeiPayMethod.active) || {})
                    .payableNum,
                ) || null,
            },
            false,
          );
      }
      this.point = false;
    },
    async getOrderDetail(orderNo) {
      const res = await reqOrderDetail(orderNo);
      const orderDetail = res.data;
      orderDetail.packageProductList.forEach((m) => {
        this.memberPackage = m.packageType === 2;
      });
    },
  },
  destroyed() {
    sessionStorage.removeItem('payable');
  },
};
</script>

<style lang="scss" scoped>
.checkOut {
  width: 100%;
  padding-top: 100px;
  padding-bottom: 240px;
  background: #f9f9f9;
  user-select: none;
  .checkOutLoading {
    margin-top: 100px;

    .van-loading__text {
      margin-top: 20px;
    }
  }

  .orderInfo {
    margin-bottom: 47px;

    .orderPrice {
      padding: 47px 0 14px;
      color: #333;
      font-weight: bold;
      font-size: 43px;
      text-align: center;
    }

    .orderDiscount,
    .orderNo {
      font-size: 25px;
      text-align: center;

      .text {
        color: #787878;
        user-select: unset;
      }
    }

    .orderDiscount {
      margin-bottom: 18px;

      .price {
        color: #ff6c02;
      }
    }

    .orderNo {
      display: flex;
      align-items: center;
      justify-content: center;

      .copyButton {
        width: 43px;
        height: 43px;
        background: url('../../assets/img/payment/copy_button.png') no-repeat center;
        background-size: contain;
      }
    }
  }

  .payInfo {
    width: 100%;
    padding: 0 36px;

    .sectionTitle {
      height: 98px;
      font-weight: bold;
      font-size: 29px;
      line-height: 98px;
    }
  }

  .pay-agreement {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    margin-top: 36px;
    margin-right: 36px;

    span {
      color: #787878;
      font-size: 22px;
      line-height: 36px;

      // &:last-child {
      //   text-decoration: underline;
      // }
    }
  }

  .payProtocol {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    // padding: 36px 36px 243px 0;
    color: #787878;
    font-size: 22px;
    line-height: 36px;
    text-align: right;

    a {
      text-decoration: underline;
    }

    &::after {
      display: inline-block;
      width: 29px;
      height: 29px;
      background: url('../../assets/img/payment/unselect.png') no-repeat center center;
      background-size: contain;
      content: '';
    }

    &Active::after {
      background-image: url('../../assets/img/payment/selected.png');
    }
  }
  .handsel {
    position: fixed;
    right: 0;
    bottom: 150px;
    left: 0;
    color: #ff6c02;
    font-weight: 400;
    font-size: 22px;
    line-height: 31px;
    text-align: center;
  }
  .bottomButton {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    background: #fff;

    .customerService {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 74px;
      color: #ff6c02;
      font-size: 22px;
      line-height: 74px;
      text-align: center;
      background: rgba(255, 108, 2, 0.1);
      cursor: pointer;

      .customerServiceIcon {
        display: inline-block;
        width: 43px;
        height: 43px;
        margin-left: -7px;
        background: url('../../assets/img/payment/go_service.png') no-repeat center;
        background-size: contain;
      }
    }

    button {
      height: 84px;
      margin: 20px 36px;
      color: #fff;
      font-size: 29px;
      line-height: 84px;
      background: #ff6c02;
      border-radius: 41px;
      cursor: pointer;

      &.buttonUnactive {
        background: #ccc;
      }
    }
  }
}

.inApp {
  padding-top: 0;
}
</style>
